export default "__VITE_ASSET__Dy2K6Cbd__"